export default __webpack_public_path__ + "static/media/comp.e9c2e0b8.png";